import borrowing from '@/api/wholesale/borrowing-spare-part'
import wholesale from '@/api/wholesale/operation'
import httpClient from '@/http-client'
import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty, join, split } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  location_id: [],
  branch_id: [],
  service_type_id: [],

  formModels: {
    customer: [],
    product: [],
    employee: [],
    serviceType: [],
    vehiclePlate: [],
    mainProduct: [],
    serviceField: [],
    location: []
  },
  isReturn: false,
  isTrashed: false,
  dateRange: [
    moment()
      .add(-1, 'months')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  customers: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formModels = data
    } else {
      split(index, ',').forEach(el => {
        state.formModels[el] = data[el]
      })
    }
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  PUSH_NEW_CUSTOMER(state, data) {
    state.formModels.customer.push(data)
  },
  SET_STATUS(state, data) {
    state.isReturn = data
  },
  SET_TRASHED(state, data) {
    state.isTrashed = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_SERVICE_TYPE_ID(state, data) {
    state.service_type_id = data
  },
  SET_CUSTOMER(state, data) {
    state.customers = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: join(context.state.dateRange, ','),
          is_return: context.state.isReturn,
          location_id: context.state.location_id,
          branch_id: context.state.branch_id,
          service_type_id: context.state.service_type_id,
          is_deleted: context.state.isTrashed
        }
      },
      attributes
    )
    return borrowing.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return borrowing.store(data)
  },
  generateInv(context, data) {
    return borrowing.generateInv(data)
  },
  update(context, { id, data }) {
    return borrowing.update(id, data)
  },
  updateRef(context, { id, data }) {
    return borrowing.updateRef(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await borrowing.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
    return Promise.resolve()
  },
  destroy(context, id) {
    return borrowing.destroy(id)
  },
  previewPdf(context, data) {
    let params = {
      sfo_id: data.sfo_id,
      paper_size: data.paper_size
    }
    return borrowing.toPdf(data.sfo_id, { params })
  },
  findEngine(context, id) {
    return borrowing.findEngine(id)
  },
  combineInvoice(context, attributes = {}) {
    return borrowing.combineInvoice({ params: attributes })
  },
  productBalance(context, data) {
    return borrowing.productBalance(data)
  },
  async getFormViewData(context, { params, index }) {
    let response = await borrowing.formModel({ params: params })
    context.commit('SET_VIEW_MODELS', {
      data: response.data,
      index: index
    })
    return response
  },
  getLocation(context, attrubutes = {}) {
    return borrowing.getLocation({ params: attrubutes })
  },
  async exportExcel(context, attrubutes = {}) {
    let params = Object.assign(
      {
        branch_id: context.state.branch_id,
        search: context.state.search,
        location_id: context.state.location_id,
        is_return: context.state.isReturn,
        is_deleted: context.state.isTrashed,
        date_between: context.state.dateRange
          ? join(context.state.dateRange, ',')
          : undefined
      },
      attrubutes
    )
    return httpClient.post(
      '/api/v1/borrowing-spare-parts/export-excels',
      params,
      {
        responseType: 'arraybuffer'
      }
    )
  },
  async getCustomer(context, search) {
    let var_customer = await wholesale.formViewModel({
      params: {
        fnName: 'customer',
        search_customer: search
      }
    })
    context.commit('SET_CUSTOMER', var_customer.data['customer'])
  }
}
